<template>
    <div id="deliveryDetails">
        <van-nav-bar :border="false" title="快递详情" left-arrow @click-left="$router.go(-1);"/>
        <div class="deliveryHearder">
            <!-- <div class="deliveryHearder1">
                <van-image round src="https://img.yzcdn.cn/vant/cat.jpeg"/>
                <span class="firstSpan">宁书评</span>
                <span class="lastSpan">【派件中】</span>
            </div> -->
            <div class="deliveryHearder2">
                {{deliveryDetailsDetail.expressCompany}} {{expressInfo.LogisticCode}} <van-icon v-clipboard:copy="expressInfo.LogisticCode"  v-clipboard:success="copySucessFn" v-clipboard:error="copyErrorFn" name="column" />
            </div>
        </div>
        <div class="deliveryBody">
            <van-steps direction="vertical" :active="0">
                <van-step v-for="(item,index) in expressInfo.Traces" :key="index">
                    <h4>{{expressInfo.Traces[index].AcceptStation}}</h4>
                    <p>{{expressInfo.Traces[index].AcceptTime}}</p>
                </van-step>
            </van-steps>
        </div>
    </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';
export default {
    name: 'DeliveryDetails',
    data() {
        return {
        };
    },
    computed: {
        ...mapState('deliveryDetails', {
            deliveryDetailsDetail: 'deliveryDetailsDetail',
            expressInfo:'deliveryDetailsDetailExpressInfo'
        })
    },
    methods: {
        ...mapActions('deliveryDetails', {
            getDeliveryDetailsDetail: 'getDeliveryDetailsDetailAction'
        }),
        copySucessFn(e) {
            this.$toast.success('复制成功');
        },
        queryDetail(params){
            this.getDeliveryDetailsDetail(params).then((res) => {
                // console.log(JSON.parse(res.expressInfo));
            }).catch((res) => {
                this.$toast(res.error);
            });
        },
        copyErrorFn(e) {
            this.$toast.error('复制失败');
        }
    },
    created() {
        this.queryDetail(this.$route.query.orderNumber);
    }
};
</script>
<style lang="scss">
    #deliveryDetails{
      .van-nav-bar{
        .van-icon-arrow-left{
          font-size: 25px;
          color: #000000;
        }
        .van-nav-bar__title{
          font-size:18px;
          font-family:PingFang SC;
          font-weight:bold;
          color:rgba(0,0,0,1);
        }
      }
      .deliveryHearder{
          padding: 10px;
          background: #fff;
          margin: 10px 0;
          .deliveryHearder1{
              margin-bottom: 15px;
              .van-image{
                  width: 35px;
                  height: 35px;
                  float: left;
              }
              .firstSpan{
                    font: 16px/35px 'PingFang SCPingFang SC';
                    color: #aaa;
                    font-weight: 500;
                    margin: 0 10px;
              }
              .lastSpan{
                    font: 16px/35px 'PingFang SCPingFang SC';
                    color: #000;
                    font-weight: 500;
              }
          }
          .deliveryHearder2{
              padding: 8px;
              font-size: 13px;
              background: #F2F2F2;
              color: #aaa;
              border-radius: 5px;
          }
      }
      .deliveryBody{
          h4{
              margin: 0;
          }
      }
    }
</style>
